import Courses from '../Courses';
import CoursesCreate from '../Views/CoursesCreate';
import CoursesTable from '../Views/CoursesTable';
import CourseUpdate from '../Views/CourseUpdate'

const CoursesRoute = {
    path: '/courses',
    meta: {
        name: {
            en: 'Courses',
            es: 'Cursos',
        }
    },
    component: Courses,
    children: [
        {
            path: '',
            component: CoursesTable,
            meta: { name: { en: 'Index', es: 'Lista' }, group: 'portaladministrativo.prices', path: 'courses' },
        }, {
            path: 'create',
            component: CoursesCreate,
            meta: { name: { en: 'Create', es: 'Creación' }, group: 'portaladministrativo.prices', path: 'courses'},
        }, {
            path: 'update/:id',
            component: CourseUpdate,
            meta: { name: { en: 'Update', es: 'Actualización' }, group: 'portaladministrativo.prices', path: 'courses'},
        },
    ]
};

export default CoursesRoute 